module.exports = __webpack_public_path__ + "static/media/21ECLAC44.e0718f2e.jpg";